import { createSignalAction, createSimpleCreator } from "shared/reduxUtils"

const BASE = "SETTINGS"

export const fetchIntegrationSourcesAction = createSignalAction(BASE, "FETCH_INTERATION_SOURCE")
export const loadAccountsAction = createSignalAction(BASE, "LOAD_ACCOUNT")
export const getMultiCallerStateAction = createSignalAction(BASE, "GET_MULTICALLER_STATE")
export const changeMultiCallerStateActions = createSignalAction(BASE, "CHANGE_MULTICALLER_STATE")
